import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=b35e974c&scoped=true"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"
import style0 from "./Step.vue?vue&type=style&index=0&id=b35e974c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e974c",
  null
  
)

export default component.exports